/**
 * Classe utile pour les opérations de manipulation de chaînes de caractères
 */
export class StringUtil {

	/**
	 * Vérifie si une chaîne de caractères est nulle, indéfinie ou vide après avoir retiré les espaces.
	 * @param {string | null | undefined} value - La chaîne de caractères à vérifier.
	 * @returns {boolean} `true` si la chaîne est nulle, indéfinie ou vide, `false` sinon.
	 * @example
	 * StringUtil.isNullOrEmpty('');          // true
	 * StringUtil.isNullOrEmpty(null);        // true
	 * StringUtil.isNullOrEmpty('   ');       // true
	 * StringUtil.isNullOrEmpty('test');      // false
	 */
	static isNullOrEmpty(value?: string | null): boolean {
		return !value || value.trim() === '';
	}

}
